export default "__VITE_ASSET__DGxCYYY5__"